module.exports = __webpack_public_path__ + "static/media/see-events.bd11ea3a.png";